import { useRefinementList, UseRefinementListProps } from 'react-instantsearch';

export const RefinementListVirtual = (props: UseRefinementListProps) => {
  useRefinementList(props);
  return null;
};
